/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

/**
 * Service for generating v4 UUIDs.
 * https://jsfiddle.net/briguy37/2MVFd/
 *
 * @module enervee_utils.common
 */
function UUIDService() {
    var _pub = {};

    _pub.generate = function() {
        var d = new Date().getTime();
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = (d + Math.random()*16)%16 | 0;
            d = Math.floor(d/16);
            return (c=='x' ? r : (r&0x3|0x8)).toString(16);
        });
    };

    return _pub;
}

module.exports = UUIDService;